module.exports = __webpack_public_path__ + "static/6M_2024_Announcement_Financial_Results-295619c06dd5f6cbdacb6b9c2d04f824.pdf";